import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import BankAccount from 'dibs-icons/exports/legacy/BankAccount';
import CheckoutBankAccountMessage from './CheckoutBankAccountMessage';

//Components
import styles from './styles/CheckoutBankAccountView.scss';

import { CheckoutBankAccountView_transaction$data } from './__generated__/CheckoutBankAccountView_transaction.graphql';
import { CheckoutBankAccountView_bankAccount$data } from './__generated__/CheckoutBankAccountView_bankAccount.graphql';

export type CheckoutBankAccountViewType = {
    transaction?: CheckoutBankAccountView_transaction$data;
    bankAccount: CheckoutBankAccountView_bankAccount$data;
    hideMaskedAccount?: boolean;
    hideMessage?: boolean;
    showTitle?: boolean;
};

const CheckoutBankAccountView: FunctionComponent<CheckoutBankAccountViewType> = ({
    bankAccount,
    transaction,
    hideMaskedAccount = false,
    hideMessage = true,
    showTitle = false,
}) => {
    const display = bankAccount?.display || '';

    const maskedCardClasses = classNames(styles.maskedAccount, {
        [styles.showTitle]: showTitle,
    });

    const isMobile = false;

    return (
        <div className={styles.wrapper}>
            <BankAccount className={styles.icon} />
            {showTitle && (
                <div data-tn="bankAccount-title">
                    <FormattedMessage
                        id="checkout.CheckoutBanckAccountView.cardTitle"
                        defaultMessage="Bank Account"
                    />
                </div>
            )}
            {isMobile && !hideMessage && <CheckoutBankAccountMessage transaction={transaction} />}
            <div className={styles.info}>
                {!hideMaskedAccount && (
                    <div className={maskedCardClasses} data-tn="account-masked-number">
                        <div>{display}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default createFragmentContainer(CheckoutBankAccountView, {
    bankAccount: graphql`
        fragment CheckoutBankAccountView_bankAccount on ACH {
            display
            accountType
            accountHolderName
        }
    `,
    transaction: graphql`
        fragment CheckoutBankAccountView_transaction on Transaction {
            ...CheckoutBankAccountMessage_transaction @include(if: $isMobile)
        }
    `,
});
